(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-slider')) {
    class BannerSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        this.loop = this.dataset.loop === 'true';
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.counter = this.querySelector('[data-counter]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');

        this.prevBtn?.addEventListener('click', () => this.go(this.index - 1, true));
        this.nextBtn?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
        });

        this.onScroll = () => {
          clearTimeout(this._scrollT);
          this._scrollT = setTimeout(() => this.syncFromScroll(), 80);
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.initDrag();

        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        this.track.addEventListener('touchstart', () => this.pause(), { passive: true });
        this.track.addEventListener('touchend', () => this.play(), { passive: true });
        this.onVisibility = () => (document.hidden ? this.pause() : this.play());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.update();
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(target, user) {
        const last = this.slides.length - 1;
        let next = target;
        if (next > last) next = this.loop ? 0 : last;
        if (next < 0) next = this.loop ? last : 0;
        this.index = next;
        this.track.scrollTo({ left: this.slides[next].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.update();
        if (user) this.restart();
      }

      syncFromScroll() {
        const left = this.track.scrollLeft;
        let best = 0;
        let bestDist = Infinity;
        this.slides.forEach((slide, i) => {
          const d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        if (best !== this.index) { this.index = best; this.update(); }
      }

      update() {
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.index);
          dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
        });
        if (this.counter) this.counter.textContent = String(this.index + 1);
        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index === this.slides.length - 1;
        }
        this.slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true'));
      }

      play() {
        if (this.dataset.autoplay !== 'true' || this._timer || document.hidden) return;
        const ms = Math.max(2, Number(this.dataset.speed) || 5) * 1000;
        this._timer = setInterval(() => this.go(this.index + 1, false), ms);
      }

      pause() {
        clearInterval(this._timer);
        this._timer = null;
      }

      restart() {
        this.pause();
        if (!this.matches(':hover')) this.play();
      }

      /* Mouse drag on desktop; a drag never counts as a banner click. */
      initDrag() {
        const THRESHOLD = 8;
        let startX = 0;
        let startLeft = 0;
        let down = false;
        let moved = false;
        this.track.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          down = true;
          moved = false;
          startX = e.clientX;
          startLeft = this.track.scrollLeft;
        });
        window.addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > THRESHOLD) {
            moved = true;
            this.classList.add('is-dragging');
            this.pause();
          }
          if (moved) this.track.scrollLeft = startLeft - dx;
        });
        window.addEventListener('pointerup', (e) => {
          if (!down) return;
          down = false;
          if (!moved) return;
          this.classList.remove('is-dragging');
          const dx = e.clientX - startX;
          const width = this.track.clientWidth || 1;
          let target = this.index;
          if (dx < -width * 0.15) target = this.index + 1;
          else if (dx > width * 0.15) target = this.index - 1;
          this.go(target, true);
        });
        this.track.addEventListener('click', (e) => {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);
        this.track.addEventListener('dragstart', (e) => e.preventDefault());
      }
    }
    customElements.define('banner-slider', BannerSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-box-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bulk-box-bar')) {
    class BulkBoxBar extends HTMLElement {
      connectedCallback() {
        this.goal = Number(this.dataset.goal) || 0;
        this.symbol = this.dataset.symbol || '₹';
        this.onCart = (e) => {
          const cart = e?.detail?.resource;
          if (cart && typeof cart.items_subtotal_price === 'number' && typeof cart.item_count === 'number') this.render(cart);
          else this.refresh();
        };
        document.addEventListener('cart:update', this.onCart);
        this.onShow = (e) => { if (e.persisted) this.refresh(); };
        window.addEventListener('pageshow', this.onShow);
        this.querySelector('[data-view-box]')?.addEventListener('click', () => this.openBox());
        this.refresh();
      }
      disconnectedCallback() {
        document.removeEventListener('cart:update', this.onCart);
        window.removeEventListener('pageshow', this.onShow);
      }
      money(cents) {
        const v = Math.max(0, cents) / 100;
        return this.symbol + v.toLocaleString('en-IN', { maximumFractionDigits: v % 1 ? 2 : 0 });
      }
      async refresh() {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (res.ok) this.render(await res.json());
        } catch (_) {}
      }
      render(cart) {
        const count = cart.item_count || 0;
        const subtotal = cart.items_subtotal_price || 0;
        const remaining = Math.max(0, this.goal - subtotal);
        const pct = this.goal > 0 ? Math.min(100, Math.floor((subtotal / this.goal) * 100)) : 0;
        const tpl = count === 1 ? this.dataset.titleOne : this.dataset.titleMany;
        const fill = (t) => (t || '')
          .replace(/\[count\]/g, String(count))
          .replace(/\[remaining\]/g, this.money(remaining))
          .replace(/\[goal\]/g, this.money(this.goal))
          .replace(/\[reward\]/g, this.dataset.reward || '');
        this.querySelector('[data-title]').textContent = fill(tpl);
        this.querySelector('[data-amount]').textContent = `${this.money(subtotal)}/${this.money(this.goal)}`;
        this.querySelector('[data-fill]').style.width = `${pct}%`;
        this.querySelector('[data-track]').setAttribute('aria-valuenow', String(pct));
        this.querySelector('[data-msg]').textContent = fill(remaining > 0 ? this.dataset.msgProgress : this.dataset.msgDone);
        this.classList.toggle('is-complete', remaining === 0 && this.goal > 0);
      }
      openBox() {
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
        else window.location.href = (window.Theme?.routes?.cart_url) || '/cart';
      }
    }
    customElements.define('bulk-box-bar', BulkBoxBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bulk-order-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bulk-order-grid')) {
    class BulkOrderGrid extends HTMLElement {
      connectedCallback() {
        this.qtyMap = new Map();
        this.cards = Array.from(this.querySelectorAll('[data-card]')).map((el) => this.initCard(el));
        this.onCart = (e) => {
          if (e?.detail?.sourceId === this.sourceId) return;
          const cart = e?.detail?.resource;
          if (cart && Array.isArray(cart.items)) this.applyCart(cart);
          else this.syncCart();
        };
        this.sourceId = `bulk-order-grid-${Math.random().toString(36).slice(2)}`;
        document.addEventListener('cart:update', this.onCart);
        this.onShow = (e) => { if (e.persisted) this.syncCart(); };
        window.addEventListener('pageshow', this.onShow);
        this.syncCart();
        this.initMasonry();
      }
      disconnectedCallback() {
        document.removeEventListener('cart:update', this.onCart);
        window.removeEventListener('pageshow', this.onShow);
        this.masonryObserver?.disconnect();
        window.removeEventListener('resize', this.onResize);
      }

      /* Card height → row span (rows are 2px), re-run whenever any card resizes
         (images loading, variant change, stepper swap, viewport change). */
      initMasonry() {
        const grid = this.querySelector('.bog__grid');
        if (!grid || typeof ResizeObserver === 'undefined') return;
        const ROW = 2;
        const layout = (card) => {
          const h = card.getBoundingClientRect().height;
          const gap = parseFloat(getComputedStyle(grid).getPropertyValue('--bog-row-gap')) || 0;
          if (h > 0) card.style.setProperty('--bog-span', String(Math.ceil((h + gap) / ROW)));
        };
        this.onResize = () => grid.querySelectorAll('.bog-card').forEach(layout);
        window.addEventListener('resize', this.onResize, { passive: true });
        grid.classList.add('is-masonry');
        this.masonryObserver = new ResizeObserver((entries) => entries.forEach((e) => layout(e.target)));
        grid.querySelectorAll('.bog-card').forEach((card) => {
          layout(card);
          this.masonryObserver.observe(card);
        });
      }

      initCard(el) {
        let variants = [];
        try { variants = JSON.parse(el.querySelector('[data-variants]')?.textContent || '[]'); } catch (_) {}
        const card = {
          el,
          variants,
          selects: Array.from(el.querySelectorAll('[data-option]')),
          actions: el.querySelector('[data-actions]'),
          add: el.querySelector('[data-add]'),
          stepper: el.querySelector('[data-stepper]'),
          qty: el.querySelector('[data-qty]'),
          error: el.querySelector('[data-error]'),
          img: el.querySelector('.bog-card__img'),
        };
        card.variant = variants.find((v) => String(v.id) === card.actions.dataset.variantId) || variants[0] || null;
        card.selects.forEach((sel) => sel.addEventListener('change', () => this.onOptionChange(card)));
        card.add?.addEventListener('click', () => this.addToBox(card));
        card.stepper?.querySelectorAll('[data-step]').forEach((btn) =>
          btn.addEventListener('click', () => this.step(card, Number(btn.dataset.step)))
        );
        return card;
      }

      money(cents) {
        const v = Math.max(0, cents) / 100;
        const symbol = (this.dataset.symbol || '₹');
        return `${symbol} ${v.toLocaleString('en-IN', { maximumFractionDigits: v % 1 ? 2 : 0 })}`;
      }

      onOptionChange(card) {
        const chosen = card.selects.map((s) => s.value);
        let match = card.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        card.variant = match || null;
        this.renderCard(card);
      }

      renderCard(card) {
        const v = card.variant;
        const el = card.el;
        card.error.hidden = true;
        if (!v) {
          card.add.disabled = true;
          card.add.textContent = this.dataset.soldoutLabel || 'Unavailable';
          card.add.hidden = false;
          card.stepper.hidden = true;
          return;
        }
        card.actions.dataset.variantId = String(v.id);
        const off = v.compare > v.price ? Math.floor(((v.compare - v.price) * 100) / v.compare) : 0;
        el.querySelector('[data-price]').textContent = this.money(v.price);
        const was = el.querySelector('[data-compare]');
        if (was) { was.textContent = this.money(v.compare); was.hidden = off === 0; }
        const offEl = el.querySelector('[data-off]');
        if (offEl) { offEl.hidden = off === 0; el.querySelector('[data-off-pct]').textContent = String(off); }
        const badge = el.querySelector('[data-badge]');
        if (badge) { badge.hidden = off === 0; el.querySelector('[data-badge-pct]').textContent = String(off); }
        if (v.image && card.img && card.img.tagName === 'IMG') {
          card.img.removeAttribute('srcset');
          card.img.src = v.image;
        }
        const q = this.qtyMap.get(String(v.id)) || 0;
        if (q > 0) {
          card.add.hidden = true;
          card.stepper.hidden = false;
          card.qty.textContent = String(q);
        } else {
          card.stepper.hidden = true;
          card.add.hidden = false;
          card.add.disabled = !v.available;
          card.add.textContent = v.available ? (this.dataset.addLabel || 'Add to box') : (this.dataset.soldoutLabel || 'Sold out');
        }
      }

      applyCart(cart) {
        this.qtyMap.clear();
        (cart.items || []).forEach((item) => {
          const k = String(item.variant_id);
          this.qtyMap.set(k, (this.qtyMap.get(k) || 0) + item.quantity);
        });
        this.cards.forEach((c) => this.renderCard(c));
      }

      async syncCart() {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (res.ok) this.applyCart(await res.json());
        } catch (_) {}
      }

      sectionIds() {
        return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
      }

      dispatch(cart, sections, variantId) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.sourceId,
            data: {
              source: 'bulk-order-grid',
              itemCount: cart.item_count,
              variantId: String(variantId),
              sections: sections || {},
              openDrawer: false,
            },
          },
        }));
      }

      showError(card, msg) {
        card.error.textContent = msg || 'Something went wrong. Please try again.';
        card.error.hidden = false;
      }

      async addToBox(card) {
        const v = card.variant;
        if (!v || !v.available) return;
        card.add.classList.add('is-loading');
        try {
          const sections = this.sectionIds();
          const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message);
          const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartRes.json();
          this.applyCart(cart);
          this.dispatch(cart, data.sections, v.id);
        } catch (err) {
          this.showError(card, err?.message);
        } finally {
          card.add.classList.remove('is-loading');
        }
      }

      async step(card, delta) {
        const v = card.variant;
        if (!v) return;
        const current = this.qtyMap.get(String(v.id)) || 0;
        const next = Math.max(0, current + delta);
        card.stepper.classList.add('is-loading');
        try {
          const sections = this.sectionIds();
          const res = await fetch(`${window.Theme?.routes?.cart_update_url || '/cart/update'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: { [v.id]: next }, sections }),
          });
          const cart = await res.json();
          if (!res.ok || cart.status) throw new Error(cart.description || cart.message);
          this.applyCart(cart);
          this.dispatch(cart, cart.sections, v.id);
        } catch (err) {
          this.showError(card, err?.message);
        } finally {
          card.stepper.classList.remove('is-loading');
        }
      }
    }
    customElements.define('bulk-order-grid', BulkOrderGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["num-icon-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root = document) => {
      root.querySelectorAll('[data-nit-sticky]').forEach((bar) => {
        if (bar.dataset.nitReady) return;
        bar.dataset.nitReady = '1';
        const section = bar.closest('.nit');
        const afterScroll = bar.dataset.afterScroll === 'true';
        // Keep the page's last content (footer) clear of the fixed bar.
        const pad = () => {
          const visible = getComputedStyle(bar).display !== 'none';
          document.body.style.paddingBottom = visible ? `${bar.offsetHeight}px` : '';
        };
        const onScroll = () => {
          if (!afterScroll || !section) return;
          bar.classList.toggle('is-hidden', section.getBoundingClientRect().top > window.innerHeight * 0.5);
        };
        pad();
        onScroll();
        window.addEventListener('resize', pad, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
